import { Star, Droplet } from "lucide-react";
import { parseISO } from "date-fns";
import { infoForDate } from "@/lib/cycle";
import { faithDaysOn } from "@/lib/faith-customs";

const BLEED = ["Spotting", "Light", "Medium", "Heavy"];

// Faith fasting/holy day on the selected calendar day, with a period-aware tip when they overlap
export const FaithDayNote = ({ faith, iso, cycle }) => {
  const days = faith ? faithDaysOn(faith, iso) : [];
  if (!days.length) return null;
  const onPeriod = BLEED.includes(cycle.logs[iso]?.flow) || infoForDate(cycle, parseISO(iso))?.phase === "menstrual";
  return (
    <div className="mt-4 space-y-2" data-testid="faith-day-note">
      {days.map((d) => (
        <div key={d.name} className="rounded-2xl border border-[#C86D51]/20 bg-[#FBF5EE] p-4">
          <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-[#9E4429]">
            <Star className="h-3.5 w-3.5" /><span data-testid="faith-day-name">{d.name}</span> · {d.kind === "fast" ? "Fasting" : "Holy day"}
          </p>
          {onPeriod ? (
            <p className="mt-2 flex items-start gap-2 text-sm text-[#3D302B]" data-testid="faith-day-period-tip"><Droplet className="mt-0.5 h-4 w-4 shrink-0 text-[#A9503A]" />{d.periodTip}</p>
          ) : (
            <p className="mt-2 text-sm text-[#3D302B]" data-testid="faith-day-tip">{d.tip}</p>
          )}
        </div>
      ))}
    </div>
  );
};
